import type { EventAthlete } from '@/lib/watch/eventAthletes'
import type { StageGraphic } from '@/lib/watch/graphics'
import type { Race } from '@/lib/watch/races'

/** What every broadcast element draws from besides its spec: the event, its races and the roster the page holds. */
export interface BroadcastContext {
  eventId: string
  races: readonly Race[]
  /** The public roster by athlete id, for names and photos (empty before it loads). */
  roster: ReadonlyMap<string, EventAthlete>
  /** Upright on a phone: a lower third is one line over the video, and a panel shows its top five. */
  compact: boolean
  /** At most this many rows on a board whatever it asks (a phone on its side: wide but short); null for no cap. */
  maxRows?: number | null
}

/** An element's props: its spec, the page's context, and whether it is the host's own preview. */
export interface BroadcastElementProps<Spec extends StageGraphic = StageGraphic> {
  spec: Spec
  context: BroadcastContext
  /** Only this host sees it (hover in the console): marked Preview, as a camera preview is. */
  preview?: boolean
}

/** A roster by id, for `BroadcastContext.roster`. */
export function rosterById(roster: readonly EventAthlete[]): ReadonlyMap<string, EventAthlete> {
  return new Map(roster.map((athlete) => [athlete.id, athlete]))
}
